import React from 'react';
import { Button, Input, Row, Typography, Modal, Spin } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWater, faTrashAlt, faSave, faBuilding, faUserTie, faUniversity, faCheckDouble, faEye, faTimes } from '@fortawesome/free-solid-svg-icons'
import { addBusinessDetailsApi, updateBusinessDetailsApi, fileUploadApi, imageBusinessDetailsApi, imageOwnerDetailsApi,
  imageBankDetailsApi, getBase64, paymentSummaryStripeApi, deleteImageBusinessDetailsApi, 
  deleteImageOwnerDetailsApi, deleteImageBankDetailsApi, stringFormat } from './utils/ApiUtils';
import { COLORS, STRINGS } from './utils/Constants';

const Entities = require('html-entities').AllHtmlEntities;
const entities = new Entities();
const { Text } = Typography;

let inputStyleDisabled = { width: '75%', fontSize: 14, fontFamily: 'OpenSans-Bold' };
let textStyle = { fontSize: 14, fontFamily: 'OpenSans-Bold', textAlign:'left', marginBottom: 0, color: COLORS.cccWhite, marginLeft: 8 };

let warningText = "Please complete the above section to activate below sections.";
let warningText2 = "The above details CANNOT be changed once submitted. Please double check everything.";
let bankText = "Clicking the above button will take you to a 'Stripe Connected Account' page where you will need to provide details and official documents related to you, your business, and your bank.";
let bankText3 = "These details will help establish your identity and ownership for us to process your movie listing and transfer your share of ticket revenue to your bank.";
let bankText2 = "Please take utmost care in filling out ALL the details.\nPlease complete all the details in one sitting.";
let checkAccountText = "Clicking the above button will take you to a 'Stripe Connected Account' page where you will be able to see your bank details.";
let supportEmail = "Support Email: hello@hit.movie";

export default class BankDetails extends React.Component {
  state = {
    movieUploadId: '', businessObj: '', website: '', panNumber: '', gstNumber: '', regDocName: '', formDisabled: false, 
    address1: '', address2: '', city: '', postalCode: '', state: '', panFile: '', gstFile: '', registrationFile: '',
    ownerName: '', ownerDob: '', designation: '', ownerPan: '', ownerAadhar: '', detailsCompleted: false,
    ownerAddress1: '', ownerAddress2: '', ownerCity: '', ownerPostalCode: '', ownerState: '', ownerPanFile: '',
    aadharFrontFile: '', aadharBackFile: '', bankName: '', bankBranch: '', ifscCode: '', accountNumber: '',
    confirmAccount: '', chequeFile: '', disableAll: false, modalImage: '', save1: false, save2: false, save3: false,
    saving1: false, saving2: false, saving3: false, errorMessage: '', chequeNumber: '', confirmSubmit: 0, movieObj: '',
  };
  componentDidMount() {
    let sessionValue = localStorage.getItem('localStorageSession') || '';
    console.log('sessionValue='+sessionValue);
    if(sessionValue) {
      this.setState({ sessionValue: sessionValue });
    }
    let businessObj = this.props.businessObj;
    if((!businessObj)&&(!this.state.businessObj)) {
      console.log('businessObj =2');
      this.setState({ confirmSubmit: 0, businessObj: '', website: '', panNumber: '', gstNumber: '', regDocName: '', chequeNumber: '',
        address1: '', address2: '', city: '', postalCode: '', state: '', ownerName: '', ownerDob: '', designation: '', 
        ownerPan: '', ownerAadhar: '', ownerAddress1: '', ownerAddress2: '', ownerCity: '', aadharFrontImage: '', aadharBackImage: '',
        ownerPostalCode: '', ownerState: '', bankName: '', bankBranch: '', ifscCode: '', accountNumber: '', confirmAccount: '', 
        disableAll: '', panImage: '', gstImage: '', registrationImage: '', ownerPanImage: '', chequeImage: '',
        formDisabled: true, updatedTIme: 0, detailsCompleted: false });
    }
    this.inputElementPan = '';
    this.inputElementGst = '';
    this.inputElementRegistration = '';
    this.inputElementOwnerPan = '';
    this.inputElementCheque = '';
    this.inputElementFront = '';
    this.inputElementBack = '';
  }
  componentDidUpdate() {
    let businessObj = this.props.businessObj;
    let propsMovieObj = this.props.movieObj;
    let extraInfo = this.props.extraInfo;
    console.log('businessObj =1');
    if(extraInfo&&(this.state.movieObj!==propsMovieObj)) {
      console.log('businessObj =4 movie changed');
      let { id, username, legalEntityCountry } = propsMovieObj;
      let { contactMobileNumber, contactEmailAddress, legalEntityName } = extraInfo;
      username = stringFormat(username, entities);
      contactMobileNumber = stringFormat(contactMobileNumber, entities);
      contactEmailAddress = stringFormat(contactEmailAddress, entities);
      legalEntityName = stringFormat(legalEntityName, entities);
      legalEntityCountry = stringFormat(legalEntityCountry, entities);
      this.setState({ confirmSubmit: 0, movieUploadId: id, name: username, mobile: contactMobileNumber, 
        email: contactEmailAddress, entity: legalEntityName, country: legalEntityCountry, 
        updatedTIme: 0, detailsCompleted: false, movieObj: propsMovieObj });
    } 
    this.fillBusinessDetails(businessObj);
  }
  fillBusinessDetails = (businessObj) => {
    if(businessObj&&businessObj.id&&(businessObj.id!==this.state.businessObj.id)) {
      console.log('check businessObj='+JSON.stringify(businessObj));
      let { website, panNumber, gstNumber, registrationDocumentName, businessAddressLine1, businessAddressLine2, 
        postalCode, city, state, businessOwner, bankDetails, mediaLinks } = businessObj;
      let { fullName, dateOfBirth, designation, aadharNumber, addressLine1, addressLine2 } = businessOwner;
      let { chequeNumber, ifscCode, accountNumber, bankName, bankBranch } = bankDetails;
      
      businessAddressLine1 = stringFormat(businessAddressLine1, entities);
      businessAddressLine2 = stringFormat(businessAddressLine2, entities);
      dateOfBirth = stringFormat(dateOfBirth, entities);
      fullName = stringFormat(fullName, entities);
      addressLine1 = stringFormat(addressLine1, entities);
      addressLine2 = stringFormat(addressLine2, entities);

      console.log('businessObj PAN='+mediaLinks.PAN);
      this.setState({ businessObj: businessObj, website: website, confirmSubmit: 0, formDisabled: false, updatedTIme: businessObj.updatedTIme,
        panNumber: panNumber, gstNumber: gstNumber, regDocName: registrationDocumentName, address1: businessAddressLine1, 
        address2: businessAddressLine2, city: city, postalCode: postalCode, 
        state: state, ownerName: fullName, ownerDob: dateOfBirth, designation: designation, 
        ownerPan: businessOwner.panNumber, ownerAadhar: aadharNumber, chequeNumber: chequeNumber,
        ownerAddress1: addressLine1, ownerAddress2: addressLine2, ownerCity: businessOwner.city, 
        ownerPostalCode: businessOwner.postalCode, ownerState: businessOwner.state, bankName: bankName, bankBranch: bankBranch, 
        ifscCode: ifscCode, accountNumber: accountNumber, confirmAccount: bankDetails.accountNumber, 
        disableAll: businessObj.confirmed, aadharFrontImage: businessOwner.mediaLinks.AADHARFRONT, 
        aadharBackImage: businessOwner.mediaLinks.AADHARBACK,
        panImage: mediaLinks.PAN, gstImage: mediaLinks.GST, registrationImage: mediaLinks.RegistrationDocument,
        ownerPanImage: businessOwner.mediaLinks.PAN, chequeImage: bankDetails.mediaLinks.CHEQUE,
        detailsCompleted: businessObj.detailsCompleted });
    } else if((!businessObj||!businessObj.id)&&(this.state.businessObj)) {
      console.log('businessObj =2');
      this.setState({ confirmSubmit: 0, businessObj: '', website: '', panNumber: '', gstNumber: '', regDocName: '', chequeNumber: '',
        address1: '', address2: '', city: '', postalCode: '', state: '', ownerName: '', ownerDob: '', designation: '', 
        ownerPan: '', ownerAadhar: '', ownerAddress1: '', ownerAddress2: '', ownerCity: '', aadharFrontImage: '', aadharBackImage: '',
        ownerPostalCode: '', ownerState: '', bankName: '', bankBranch: '', ifscCode: '', accountNumber: '', confirmAccount: '', 
        disableAll: '', panImage: '', gstImage: '', registrationImage: '', ownerPanImage: '', chequeImage: '',
        formDisabled: true, updatedTIme: 0, detailsCompleted: false });
    }
  }
  handleWebsite = (e) => {
    let value = e.target.value;
    this.setState({ website: value, save1: true });
  }
  handlePanNumber = (e) => {
    let value = e.target.value;
    this.setState({ panNumber: value, save1: true });
  }
  handleGstNumber = (e) => {
    let value = e.target.value;
    this.setState({ gstNumber: value, save1: true });
  }
  handleRegDocName = (e) => {
    let value = e.target.value;
    this.setState({ regDocName: value, save1: true });
  }
  handleAddress1 = (e) => {
    let value = e.target.value;
    this.setState({ address1: value, save1: true });
  }
  handleAddress2 = (e) => {
    let value = e.target.value;
    this.setState({ address2: value, save1: true });
  }
  handleCity = (e) => {
    let value = e.target.value;
    this.setState({ city: value, save1: true });
  }
  handlePostalCode = (e) => {
    let value = e.target.value;
    this.setState({ postalCode: value, save1: true });
  }
  handleState = (e) => {
    let value = e.target.value;
    this.setState({ state: value, save1: true });
  }
  handleOwnerName = (e) => {
    let value = e.target.value;
    this.setState({ ownerName: value, save2: true });
  }
  handleDob = (e) => {
    let value = e.target.value;
    this.setState({ ownerDob: value, save2: true });
  }
  handleDesignation = (e) => {
    let value = e.target.value;
    this.setState({ designation: value, save2: true });
  }
  handleOwnerPanNumber = (e) => {
    let value = e.target.value;
    this.setState({ ownerPan: value, save2: true });
  }
  handleAadhar = (e) => {
    let value = e.target.value;
    this.setState({ ownerAadhar: value, save2: true });
  }
  handleOwnerAddress1 = (e) => {
    let value = e.target.value;
    this.setState({ ownerAddress1: value, save2: true });
  }
  handleOwnerAddress2 = (e) => {
    let value = e.target.value;
    this.setState({ ownerAddress2: value, save2: true });
  }
  handleOwnerCity = (e) => {
    let value = e.target.value;
    this.setState({ ownerCity: value, save2: true });
  }
  handleOwnerPostal = (e) => {
    let value = e.target.value;
    this.setState({ ownerPostalCode: value, save2: true });
  }
  handleOwnerState = (e) => {
    let value = e.target.value;
    this.setState({ ownerState: value, save2: true });
  }
  handleBankName = (e) => {
    let value = e.target.value;
    this.setState({ bankName: value, save3: true });
  }
  handleBankBranch = (e) => {
    let value = e.target.value;
    this.setState({ bankBranch: value, save3: true });
  }
  handleIfsc = (e) => {
    let value = e.target.value;
    this.setState({ ifscCode: value, save3: true });
  }
  handleAccountNumber = (e) => {
    let value = e.target.value;
    this.setState({ accountNumber: value, save3: true });
  }
  handleConfirmAccount = (e) => {
    let value = e.target.value;
    this.setState({ confirmAccount: value, save3: true });
  }
  handleChequeNumber = (e) => {
    let value = e.target.value;
    this.setState({ chequeNumber: value, save3: true });
  }
  confirmSubmitClicked = (detailsEnabled) => {
    if(detailsEnabled) {
      let confirmSubmit = this.state.confirmSubmit;
      if(confirmSubmit===1) {
        this.setState({ confirmSubmit: 2 });
        this.updateBusinessDetails(true);
      } else {
        this.setState({ confirmSubmit: 1 });
      }
    }
  }
  updateBusinessDetails = (confirm, index) => {
    let sessionValue = this.state.sessionValue;
    console.log('sessionValue='+sessionValue);

    let businessObj = this.state.businessObj;
    if(!(businessObj||businessObj.id)) {
      alert('Please save Business Details first.');
      this.setState({ save1: false, save2: false, save3: false, saving1: false, saving2: false, saving3: false });
      return;
    }
    let bodyObj = { businessDetailsId: businessObj.id };
    let businessDocuments = [], businessOwnerDocuments = [], bankDocuments = [];
    if(index===1) {
      let website = this.state.website;
      let panNumber = this.state.panNumber;
      let gstNumber = this.state.gstNumber;
      let regDocName = this.state.regDocName;
      let addressLine1 = this.state.address1;
      let addressLine2 = this.state.address2;
      let city = this.state.city;
      let postalcode = this.state.postalCode;
      let state = this.state.state;
      if(website) {
        bodyObj['website'] = website;
      }
      if(panNumber) {
        bodyObj['panNumber'] = panNumber;
      }
      if(gstNumber) {
        bodyObj['gstNumber'] = gstNumber;
      }
      if(regDocName) {
        bodyObj['regDocName'] = regDocName;
      }
      if(addressLine1) {
        bodyObj['addressLine1'] = addressLine1;
      }
      if(addressLine2) {
        bodyObj['addressLine2'] = addressLine2;
      }
      if(city) {
        bodyObj['city'] = city;
      }
      if(state) {
        bodyObj['state'] = state;
      }
      if(postalcode) {
        bodyObj['postalcode'] = postalcode;
      }
      if(panNumber) {
        bodyObj['panNumber'] = panNumber;
      }
      if(addressLine1) {
        bodyObj['addressLine1'] = addressLine1;
      }
      if(addressLine2) {
        bodyObj['addressLine2'] = addressLine2;
      }
      let panFile = this.state.panFile;
      let gstFile = this.state.gstFile;
      let registrationFile = this.state.registrationFile;
      if(panFile) {
        businessDocuments.push({ 'type': 'PAN', 'filename': panFile });
      }
      if(gstFile) {
        businessDocuments.push({ 'type': 'GST', 'filename': gstFile });
      }
      if(registrationFile) {
        businessDocuments.push({ 'type': 'RegistrationDocument', 'filename': registrationFile });
      }
      bodyObj['businessDocuments'] = businessDocuments;
    }
    if(index===2) {
      // business Owner Details
      let businessOwnerId = businessObj.businessOwner.id;
      let ownerName = this.state.ownerName;
      let ownerDob = this.state.ownerDob;
      let ownerPan = this.state.ownerPan;
      let designation = this.state.designation;
      let ownerAadhar = this.state.ownerAadhar;
      let ownerAddress1 = this.state.ownerAddress1;
      let ownerAddress2 = this.state.ownerAddress2;
      let ownerCity = this.state.ownerCity;
      let ownerPostalCode = this.state.ownerPostalCode;
      let ownerState = this.state.ownerState;
      if(businessOwnerId) {
        bodyObj['businessOwnerId'] = businessOwnerId;
      }
      if(ownerName) {
        bodyObj['fullName'] = ownerName;
      }
      if(ownerDob) {
        bodyObj['dob'] = ownerDob;
      }
      if(designation) {
        bodyObj['designation'] = designation;
      }
      if(ownerPan) {
        bodyObj['ownerPanNumber'] = ownerPan;
      }
      if(ownerAadhar) {
        bodyObj['aadharNumber'] = ownerAadhar;
      }
      if(ownerAddress1) {
        bodyObj['ownerAddressLine1'] = ownerAddress1;
      }
      if(ownerAddress2) {
        bodyObj['ownerAddressLine2'] = ownerAddress2;
      }
      if(ownerCity) {
        bodyObj['ownerCity'] = ownerCity;
      }
      if(ownerState) {
        bodyObj['ownerState'] = ownerState;
      }
      if(ownerPostalCode) {
        bodyObj['ownerPostalcode'] = ownerPostalCode;
      }
      let ownerPanFile = this.state.ownerPanFile;
      let aadharFrontFile = this.state.aadharFrontFile;
      let aadharBackFile = this.state.aadharBackFile;      
      if(ownerPanFile) {
        businessOwnerDocuments.push({ 'type': 'PAN', 'filename': ownerPanFile });
      }
      if(aadharFrontFile) {
        businessOwnerDocuments.push({ 'type': 'AADHARFRONT', 'filename': aadharFrontFile });
      }
      if(aadharBackFile) {
        businessOwnerDocuments.push({ 'type': 'AADHARBACK', 'filename': aadharBackFile });
      }
      bodyObj['businessOwnerDocuments'] = businessOwnerDocuments;
    }
    if(index===3) {
      // bank Details
      let bankDetailsId = businessObj.bankDetails.id;
      let bankName = this.state.bankName;
      let bankBranch = this.state.bankBranch;
      let ifscCode = this.state.ifscCode;
      let accountNumber = this.state.accountNumber;  
      let confirmAccount = this.state.confirmAccount;  
      let chequeNumber = this.state.chequeNumber;
      if(accountNumber!==confirmAccount) {
        this.setState({ errorMessage: 'Account numbers do not match. Please check.', saving3: false });
        setTimeout(
          () => this.setState({ errorMessage: '' }), 
          5000
        );
        return;
      }  
      if(bankDetailsId) {
        bodyObj['bankDetailsId'] = bankDetailsId;
      }
      if(bankName) {
        bodyObj['bankName'] = bankName;
      }
      if(bankBranch) {
        bodyObj['bankBranch'] = bankBranch;
      }
      if(ifscCode) {
        bodyObj['ifscCode'] = ifscCode;
      }
      if(accountNumber) {
        bodyObj['accountNumber'] = accountNumber;
      }
      if(confirmAccount) {
        bodyObj['confirmAccountNumber'] = confirmAccount;
      }
      if(chequeNumber) {
        bodyObj['chequeNumber'] = chequeNumber;
      }
      let chequeFile = this.state.chequeFile;
      if(chequeFile) {
        bankDocuments.push({ 'type': 'CHEQUE', 'filename': chequeFile });
      }
      bodyObj['bankDocuments'] = bankDocuments;
    }        
    console.log('obdyObj='+JSON.stringify(bodyObj));    
    // return;
    updateBusinessDetailsApi(sessionValue, bodyObj, confirm)
    .then(response => {
      console.log('Update business data='+JSON.stringify(response));
      if(response.ok) {
        let newBusinessObj = response.info;
        this.setState({ disableAll: newBusinessObj.confirmed, detailsCompleted: newBusinessObj.detailsCompleted });
        if(newBusinessObj.putMediaLinks&&(Object.keys(newBusinessObj.putMediaLinks).length>0||Object.keys(newBusinessObj.businessOwner.putMediaLinks).length>0||Object.keys(newBusinessObj.bankDetails.putMediaLinks).length>0)) { 
          this.uploadMediaFiles(sessionValue, newBusinessObj, newBusinessObj.putMediaLinks);
        } else {
          this.setState({ save1: false, save2: false, save3: false, saving1: false, saving2: false, saving3: false });
        }
      } else {
        console.log('Update Business Data failed!');
        this.setState({ save1: false, save2: false, save3: false, saving1: false, saving2: false, saving3: false });
        alert(response.info);
      }
    })
    .catch((error) => {
      console.log('Error Business Update data='+JSON.stringify(error));
      this.setState({ save1: false, save2: false, save3: false, saving1: false, saving2: false, saving3: false });
    });
  }
  uploadMediaFiles = (sessionValue, newBusinessObj, mediaLinks) => {
    let panUrl = mediaLinks.PAN;
    let gstUrl = mediaLinks.GST;
    let uploadId = this.state.movieUploadId;
    let registrationUrl = mediaLinks.RegistrationDocument;
    let ownerPanUrl = newBusinessObj.businessOwner.putMediaLinks.PAN;
    let aadharFrontUrl = newBusinessObj.businessOwner.putMediaLinks.AADHARFRONT;
    let aadharBackUrl = newBusinessObj.businessOwner.putMediaLinks.AADHARBACK;
    let chequeUrl = newBusinessObj.bankDetails.putMediaLinks.CHEQUE;
    console.log('pan='+panUrl+' gst='+gstUrl+' reg='+registrationUrl+' ownerPanUrl='+ownerPanUrl+' chequeUrl='+chequeUrl);
    if(panUrl) {
      let panFile = this.state.panFile;
      fileUploadApi(sessionValue, panUrl, this.state.panDoc)
      .then(response => {
        console.log('Update business data='+JSON.stringify(response));
        if(response) {
          imageBusinessDetailsApi(sessionValue, uploadId, newBusinessObj.id, 'save_db', 'PAN', panFile).then(response => {
            console.log('image update data='+JSON.stringify(response));
            this.setState({ save1: false, saving1: false });
          });
        } else {
          console.log('PAN Upload failed!');
          alert('PAN Upload Failed!');
          this.setState({ save1: false, saving1: false });
        }
      })
      .catch((error) => {
        console.log('Error Business Update data='+JSON.stringify(error));
        this.setState({ save1: false, saving1: false });
      });
    }
    if(gstUrl) {
      let gstFile = this.state.gstFile;
      fileUploadApi(sessionValue, gstUrl, this.state.gstDoc)
      .then(response => {
        console.log('Update business data='+JSON.stringify(response));
        if(response) {
          imageBusinessDetailsApi(sessionValue, uploadId, newBusinessObj.id, 'save_db', 'GST', gstFile).then(response => {
            console.log('image update data='+JSON.stringify(response));
            this.setState({ save1: false, saving1: false });
          });
        } else {
          console.log('GST Upload failed!');
          alert('GST Upload Failed!');
          this.setState({ save1: false, saving1: false });
        }
      })
      .catch((error) => {
        console.log('Error Business Update data='+JSON.stringify(error));
        this.setState({ save1: false, saving1: false });
      });
    }
    if(registrationUrl) {
      let registrationFile = this.state.registrationFile;
      fileUploadApi(sessionValue, registrationUrl, this.state.registrationDoc)
      .then(response => {
        console.log('Update business data='+JSON.stringify(response));
        if(response) {
          imageBusinessDetailsApi(sessionValue, uploadId, newBusinessObj.id, 'save_db', 'RegistrationDocument', registrationFile).then(response => {
            console.log('image update data='+JSON.stringify(response));
            this.setState({ save1: false, saving1: false });
          });
        } else {
          console.log('Registration Upload failed!');
          alert('Registration Upload Failed!');
          this.setState({ save1: false, saving1: false });
        }
      })
      .catch((error) => {
        console.log('Error Business Update data='+JSON.stringify(error));
        this.setState({ save1: false, saving1: false });
      });
    }
    if(ownerPanUrl) {
      let ownerPanFile = this.state.ownerPanFile;
      fileUploadApi(sessionValue, ownerPanUrl, this.state.ownerPanDoc)
      .then(response => {
        console.log('Update owner pan data='+JSON.stringify(response));
        if(response) {
          imageOwnerDetailsApi(sessionValue, uploadId, newBusinessObj.businessOwner.id, 'save_db', 'PAN', ownerPanFile).then(response => {
            console.log('owner pan update data='+JSON.stringify(response));
            this.setState({ save2: false, saving2: false });
          });
        } else {
          console.log('Owner PAN Upload failed!');
          alert('Owner PAN Upload Failed!');
          this.setState({ save2: false, saving2: false });
        }
      })
      .catch((error) => {
        console.log('Error Business Update data='+JSON.stringify(error));
        this.setState({ save2: false, saving2: false });
      });
    }
    if(aadharFrontUrl) {
      let aadharFrontFile = this.state.aadharFrontFile;
      fileUploadApi(sessionValue, aadharFrontUrl, this.state.aadharFrontDoc)
      .then(response => {
        console.log('Update aadharFront data='+JSON.stringify(response));
        if(response) {
          imageOwnerDetailsApi(sessionValue, uploadId, newBusinessObj.businessOwner.id, 'save_db', 'AADHARFRONT', aadharFrontFile).then(response => {
            console.log('aadharFront update data='+JSON.stringify(response));
            this.setState({ save2: false, saving2: false });
          });
        } else {
          console.log('aadharFront Upload failed!');
          alert('aadharFront Upload Failed!');
          this.setState({ save2: false, saving2: false });
        }
      })
      .catch((error) => {
        console.log('Error Business Update data='+JSON.stringify(error));
        this.setState({ save2: false, saving2: false });
      });
    }
    if(aadharBackUrl) {
      let aadharBackFile = this.state.aadharBackFile;
      fileUploadApi(sessionValue, aadharBackUrl, this.state.aadharBackDoc)
      .then(response => {
        console.log('Update AADHARBACK data='+JSON.stringify(response));
        if(response) {
          imageOwnerDetailsApi(sessionValue, uploadId, newBusinessObj.businessOwner.id, 'save_db', 'AADHARBACK', aadharBackFile).then(response => {
            console.log('AADHARBACK update data='+JSON.stringify(response));
            this.setState({ save2: false, saving2: false });
          });
        } else {
          console.log('AADHARBACK Upload failed!');
          alert('AADHARBACK Upload Failed!');
          this.setState({ save2: false, saving2: false });
        }
      })
      .catch((error) => {
        console.log('Error Business Update data='+JSON.stringify(error));
        this.setState({ save2: false, saving2: false });
      });
    }
    if(chequeUrl) {
      let chequeFile = this.state.chequeFile;
      fileUploadApi(sessionValue, chequeUrl, this.state.chequeDoc)
      .then(response => {
        console.log('Update cheque data='+JSON.stringify(response));
        if(response) {
          imageBankDetailsApi(sessionValue, uploadId, newBusinessObj.bankDetails.id, 'save_db', 'CHEQUE', chequeFile).then(response => {
            console.log('cheque update data='+JSON.stringify(response));
            this.setState({ save3: false, saving3: false });
          });
        } else {
          console.log('Cheque Upload failed!');
          alert('Cheque Upload Failed!');
          this.setState({ save3: false, saving3: false });
        }
      })
      .catch((error) => {
        console.log('Error Business Update data='+JSON.stringify(error));
        this.setState({ save3: false, saving3: false });
      });
    }
  }
  deleteImage = (index) => {
    // alert('Error in delete api!')
    let uploadId = this.state.movieUploadId;
    let sessionValue = this.state.sessionValue;
    let newBusinessObj = this.state.businessObj;
    switch(index) {
      case 1:
        deleteImageBusinessDetailsApi(sessionValue, uploadId, newBusinessObj.id, 'remove_db', 'PAN').then(response => {
          console.log('image delete data='+JSON.stringify(response));
          this.setState({ panImage: '' });
        });
        break;
      case 2:
        deleteImageBusinessDetailsApi(sessionValue, uploadId, newBusinessObj.id, 'remove_db', 'GST').then(response => {
          console.log('image delete data='+JSON.stringify(response));
          this.setState({ gstImage: '' });
        });
        break;
      case 3:
        deleteImageBusinessDetailsApi(sessionValue, uploadId, newBusinessObj.id, 'remove_db', 'RegistrationDocument').then(response => {
          console.log('image delete data='+JSON.stringify(response));
          this.setState({ registrationImage: '' });
        });
        break;
      case 4:
        deleteImageOwnerDetailsApi(sessionValue, uploadId, newBusinessObj.businessOwner.id, 'remove_db', 'PAN').then(response => {
          console.log('image delete data='+JSON.stringify(response));
          this.setState({ ownerPanImage: '' });
        });
        break;
      case 5:
        deleteImageBankDetailsApi(sessionValue, uploadId, newBusinessObj.bankDetails.id, 'remove_db', 'CHEQUE').then(response => {
          console.log('image delete data='+JSON.stringify(response));
          this.setState({ chequeImage: '' });
        });
        break;
      case 6:
        deleteImageOwnerDetailsApi(sessionValue, uploadId, newBusinessObj.businessOwner.id, 'remove_db', 'AADHARFRONT').then(response => {
          console.log('image delete data='+JSON.stringify(response));
          this.setState({ aadharFrontImage: '' });
        });
        break;
      case 7:
        deleteImageOwnerDetailsApi(sessionValue, uploadId, newBusinessObj.businessOwner.id, 'remove_db', 'AADHARBACK').then(response => {
          console.log('image delete data='+JSON.stringify(response));
          this.setState({ aadharBackImage: '' });
        });
        break;
      default:
        break;
    }
  }
  addBusinessDetails = () => {
    let sessionValue = this.state.sessionValue;
    console.log('sessionValue='+sessionValue);
    let uploadId = this.state.movieUploadId;
    let website = this.state.website;
    let panNumber = this.state.panNumber;
    let gstNumber = this.state.gstNumber;
    let regDocName = this.state.regDocName;
    let addressLine1 = this.state.address1;
    let addressLine2 = this.state.address2;
    let city = this.state.city;
    let postalcode = this.state.postalCode;
    let state = this.state.state;
    let panFile = this.state.panFile;
    let gstFile = this.state.gstFile;
    let registrationFile = this.state.registrationFile;
    console.log(' website='+website+' panNumber='+panNumber+' address1='+addressLine1
    +' address2='+addressLine2+' city='+city+' postal='+postalcode+' state='+state);
    let businessDocuments = [];
    if(panFile) {
      businessDocuments.push({ 'type': 'PAN', 'filename': panFile });
    }
    if(gstFile) {
      businessDocuments.push({ 'type': 'GST', 'filename': gstFile });
    }
    if(registrationFile) {
      businessDocuments.push({ 'type': 'RegistrationDocument', 'filename': registrationFile });
    }
    let tempObj = { uploadId : uploadId };
    if(website) {
      tempObj['website'] = website;
    }
    if(panNumber) {
      tempObj['panNumber'] = panNumber;
    }
    if(gstNumber) {
      tempObj['gstNumber'] = gstNumber;
    }
    if(regDocName) {
      tempObj['regDocName'] = regDocName;
    }
    if(addressLine1) {
      tempObj['addressLine1'] = addressLine1;
    }
    if(addressLine2) {
      tempObj['addressLine2'] = addressLine2;
    }
    if(city) {
      tempObj['city'] = city;
    }
    if(state) {
      tempObj['state'] = state;
    }
    if(postalcode) {
      tempObj['postalcode'] = postalcode;
    }
    if(businessDocuments.length>0) {
      tempObj['businessDocuments'] = businessDocuments;
    }
    addBusinessDetailsApi(sessionValue, tempObj)
    .then(response => {
      console.log('Add business data='+JSON.stringify(response));
      if(response.ok) {
        let newBusinessObj = response.info;
        this.setState({ disableAll: newBusinessObj.confirmed, formDisabled: false, detailsCompleted: newBusinessObj.detailsCompleted });
        if(newBusinessObj.putMediaLinks&&Object.keys(newBusinessObj.putMediaLinks).length>0) {
          this.uploadMediaFiles(sessionValue, newBusinessObj, newBusinessObj.putMediaLinks);
        } else {
          this.setState({ save1: false, saving1: false });
        }
      } else {
        console.log('Add Business Data failed!');
        alert(response.info);
        this.setState({ save1: false, saving1: false });
      }
    })
    .catch((error) => {
      console.log('Error Business Initial data='+JSON.stringify(error));
      this.setState({ save1: false, saving1: false });
    });
  }
  paymentSummary = () => {
    let sessionValue = this.state.sessionValue;
    console.log('sessionValue='+sessionValue);
    let uploadId = this.state.movieUploadId;
    if(sessionValue&&uploadId) {
      let toDate = new Date().getTime();
      console.log('toDate='+toDate);
      paymentSummaryStripeApi(sessionValue, uploadId, toDate/1000)
      .then(response => {
        console.log('paymentSummaryRazorpayApi data='+JSON.stringify(response));
        if(response.ok) {
          console.log('paymentSummaryRazorpayApi success');
        } else {
          console.log('paymentSummaryRazorpayApi  failed');
        }
      })
      .catch((error) => {
        console.log('Error paymentSummaryRazorpayApi='+JSON.stringify(error));
      });
    }
  }
  
  onDocUpload = (event, index) => {
    let file = event.target.files[0];
    console.log('index='+index+'file name='+file.name+' size='+file.size+' type='+file.type);
    getBase64(file, imageUrl => {
      // console.log('imageUrl='+imageUrl);
      let objectURL = null;
      if(file.type==='application/pdf') {
        var blob = new Blob([file], { type: "application/pdf" });
        objectURL = window.URL.createObjectURL(blob);
        console.log(objectURL);
      }
      switch(index) {
        case 1:
          this.setState({ save1: true, panImage: imageUrl, panFile: file.name, panDoc: file, panUrl: objectURL });
          break;
        case 2:
          this.setState({ save1: true, gstImage: imageUrl, gstFile: file.name, gstDoc: file, gstUrl: objectURL });
          break;
        case 3:
          this.setState({ save1: true, registrationImage: imageUrl, registrationFile: file.name, registrationDoc: file, registrationUrl: objectURL });
          break;
        case 4:
          this.setState({ save2: true, ownerPanImage: imageUrl, ownerPanFile: file.name, ownerPanDoc: file, ownerPanUrl: objectURL });
          break;
        case 5:
          this.setState({ save3: true, chequeImage: imageUrl, chequeFile: file.name, chequeDoc: file, chequeUrl: objectURL });
          break;
        case 6:
          this.setState({ save2: true, aadharFrontImage: imageUrl, aadharFrontFile: file.name, aadharFrontDoc: file, aadharFrontUrl: objectURL });
          break;
        case 7:
          this.setState({ save2: true, aadharBackImage: imageUrl, aadharBackFile: file.name, aadharBackDoc: file, aadharBackUrl: objectURL });
          break;
        default:
          break;
      }
    });
  };
  suffixDoc = (index, confirmed) => {
    let imageUrl = '', pdfUrl = '';
    let text = "Upload Document";
    let inputElement = null;
    switch(index) {
      case 1:
          imageUrl = this.state.panImage;
          pdfUrl = this.state.panUrl;
          text = 'Upload PAN';
          inputElement = this.inputElementPan;
          break;
      case 2:
          imageUrl = this.state.gstImage;
          pdfUrl = this.state.gstUrl;
          text = 'Upload GST Document';
          inputElement = this.inputElementGst;
          break;
      case 3:
          imageUrl = this.state.registrationImage;
          pdfUrl = this.state.registrationUrl;
          text = 'Upload Document';
          inputElement = this.inputElementRegistration;
          break;
      case 4:
          imageUrl = this.state.ownerPanImage;
          pdfUrl = this.state.ownerPanUrl;
          text = 'Upload PAN';
          inputElement = this.inputElementOwnerPan;
          break;
      case 5:
          imageUrl = this.state.chequeImage;
          pdfUrl = this.state.chequeUrl;
          text = 'Upload Cheque';
          inputElement = this.inputElementCheque;
          break;
      default:
          break;
    }    
    console.log('imageurl index='+index);
    return (
      imageUrl
        ?
        <div style={{ display: 'flex' }}>
          <div onClick={() => { this.showModal(imageUrl, pdfUrl) }} style={{ cursor: 'pointer', display: 'flex', justifyContent:'center', alignContent:'center', marginLeft: 8 }}>
            <FontAwesomeIcon color={COLORS.yellow} icon={faEye} style={{ fontSize: 24, alignSelf: 'center' }} />
          </div>
          { confirmed
          ?
          <div />
          :
          <div onClick={() => { this.deleteImage(index) }} style={{ cursor: 'pointer', display: 'flex', justifyContent:'center', alignContent:'center', marginLeft: 8 }}>
          <FontAwesomeIcon color={COLORS.redClose} icon={faTrashAlt} style={{ fontSize: 24, alignSelf: 'center' }} />
          </div>
          }
        </div>
        :
        <div>
          <Text onClick={() => { inputElement.click() }} style={{ fontFamily: 'OpenSans-Bold', cursor:'pointer', fontSize: 14, color: COLORS.greyaaa, backgroundColor: COLORS.eeeWhite, padding: 4, paddingLeft: 8, paddingRight: 8, borderRadius: 5 }}>
            {text}
          </Text>
          <input style={{ display:'none' }} type="file" ref={input => inputElement = input} onChange={(e) => { this.onDocUpload(e, index, inputElement) }} />   
        </div>
    );
  }
  aadharDoc = (confirmed) => {
    let aadharFront = this.state.aadharFrontImage;
    let aadharBack = this.state.aadharBackImage;
    return (
      
        <div style={{ display: 'flex' }}>
          { aadharFront
            ?
            <div style={{ display: 'flex' }}>
              <div onClick={() => { this.showModal(aadharFront, this.state.aadharFrontUrl) }} style={{ cursor: 'pointer', display: 'flex', justifyContent:'center', alignContent:'center', marginLeft: 8 }}>
                <FontAwesomeIcon color={COLORS.yellow} icon={faEye} style={{ fontSize: 24, alignSelf: 'center' }} />
              </div>
              { confirmed
              ?
              <div />
              :
              <div onClick={() => { this.deleteImage(6) }} style={{ cursor: 'pointer', display: 'flex', justifyContent:'center', alignContent:'center', marginLeft: 8 }}>
              <FontAwesomeIcon color={COLORS.redClose} icon={faTrashAlt} style={{ fontSize: 24, alignSelf: 'center' }} />
              </div>
              }
            </div>
            :
            <div>
              <Text onClick={() => { this.inputElementFront.click() }} style={{ fontFamily: 'OpenSans-Bold', cursor:'pointer', fontSize: 14, color: COLORS.greyaaa, backgroundColor: COLORS.eeeWhite, padding: 4, paddingLeft: 8, paddingRight: 8, borderRadius: 5 }}>
                Aadhar Front
              </Text>
              <input style={{ display:'none' }} type="file" ref={input => this.inputElementFront = input} onChange={(e) => { this.onDocUpload(e, 6, this.inputElementFront) }} />   
            </div>
          }
          { aadharBack
            ?
            <div style={{ display: 'flex', marginLeft: 8 }}>
              <div onClick={() => { this.showModal(aadharBack, this.state.aadharBackUrl) }} style={{ cursor: 'pointer', display: 'flex', justifyContent:'center', alignContent:'center', marginLeft: 8 }}>
                <FontAwesomeIcon color={COLORS.yellow} icon={faEye} style={{ cursor: 'pointer', fontSize: 24, alignSelf: 'center' }} />
              </div>
              { confirmed
              ?
              <div />
              :
              <div onClick={() => { this.deleteImage(7) }} style={{ display: 'flex', justifyContent:'center', alignContent:'center', marginLeft: 8 }}>
              <FontAwesomeIcon color={COLORS.redClose} icon={faTrashAlt} style={{ fontSize: 24, alignSelf: 'center' }} />
              </div>
              }
            </div>
            :
            <div>
              <Text onClick={() => { this.inputElementBack.click() }} style={{ fontFamily: 'OpenSans-Bold', marginLeft: 8, cursor:'pointer', fontSize: 14, color: COLORS.greyaaa, backgroundColor: COLORS.eeeWhite, padding: 4, paddingLeft: 8, paddingRight: 8, borderRadius: 5 }}>
                Aadhar Back
              </Text>
              <input style={{ display:'none' }} type="file" ref={input => this.inputElementBack = input} onChange={(e) => { this.onDocUpload(e, 7, this.inputElementBack) }} />   
            </div>
          }
        </div>
    );
  }
  showModal = (image, pdfUrl) => {
    this.setState({ modalImage: image, pdfUrl: pdfUrl });
  }
  handleCancel = () => {
    this.setState({ modalImage: '', pdfUrl: '' });
  }
  saveButton = (saveEnabled, index) => {
    switch (index) {
      case 1:
        this.setState({ saving1: true });
        break;
      case 2:
        this.setState({ saving2: true });
        break;
      default:
        this.setState({ saving3: true });
        break;
    }
    if(saveEnabled) {
      if(this.state.businessObj) { 
        this.updateBusinessDetails(false, index);
      } else { 
        this.addBusinessDetails(); 
      }
    } 
  }
  onDocumentLoadSuccess = ({ numPages }) => {
    console.log('doc loaded success.')
  }
  render() {
    let disabled = this.state.formDisabled;
    let confirmed = this.state.disableAll;
    let textColor = COLORS.cccWhite;
    let save1Color = COLORS.white;
    let save1BG = this.state.save1 ? COLORS.red : COLORS.yellowLight;
    let save2BG = this.state.save2 ? COLORS.red : COLORS.yellowLight;
    let save3BG = this.state.save3 ? COLORS.red : COLORS.yellowLight;
    let opacity1 = this.state.save1 ? 1 : 0.5;
    let opacity2 = this.state.save2 ? 1 : 0.5;
    let opacity3 = this.state.save3 ? 1 : 0.5;
    let detailsEnabled = this.state.detailsCompleted;
    let isIndia = this.state.country==='India';
    let accountButton = this.props.isVerified ? 'Check Your Account' : 'Setup Bank & KYC';
    let documentUrl = this.state.modalImage&&this.state.modalImage.includes('.pdf') ? this.state.modalImage : this.state.pdfUrl;
    let updatedTime = this.state.updatedTIme ? new Date(this.state.updatedTIme*1000).toString() : new Date().toString();
    console.log('uploadId='+this.state.movieUploadId);
    return (
      <div>
        <Modal
          closable={true}
          closeIcon={<FontAwesomeIcon className='modalCloseIcon'icon={faTimes} />}
          bodyStyle={{ padding: 0 }}
          centered={true}
          footer={null}
          visible={this.state.modalImage}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <div style={{ display: 'flex', justifyContent:'center', alignContent: 'center' }}>
            { documentUrl
            ?
            <object data={documentUrl} type="application/pdf" width={window.innerWidth-100} height={window.innerHeight-100}>
              <a href={documentUrl}>test.pdf</a>
            </object>
            :
            <img src={this.state.modalImage} alt="your pic" style={{ maxHeight: window.innerHeight-100, maxWidth: window.innerWidth-100 }} />
            }            
          </div>
        </Modal>
        { isIndia
        ?
        <div>
          <div style={{ marginTop: 40, border: '2px solid #1a2a3a'  }}>
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.yellow, borderBottom: '2px solid #1a2a3a' }}>
                <div style={{ display: "flex", flex:1, justifyContent:'center', alignItems: "center", width: '100%', height:'100%' }}>
                    <FontAwesomeIcon color={COLORS.darkBlue} icon={faBuilding} style={{ fontSize: 24, margin: '12px' }} />
                    <h2 style={{ fontSize: 18, fontFamily: 'OpenSans-Bold', alignSelf:'center', textAlign:'center', color: COLORS.darkBlue, marginBottom: 0 }}>
                      Business Details
                    </h2>
                    <FontAwesomeIcon color={COLORS.darkBlue} icon={faBuilding} style={{ fontSize: 24, margin: '12px' }} />                  
                </div>
                <Button onClick={() => { this.saveButton(this.state.save1, 1) }} 
                className='caption' style={{ position:'absolute', display: confirmed ? 'none' : "flex", alignItems: "center", justifyContent:'center', right: 0, 
                width: 100, height: 32, background: save1BG, borderRadius: 3, margin: 10, opacity: opacity1 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent:'center' }}>
                    { this.state.saving1
                    ?
                    <Spin size='small' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 12 }} />
                    :
                    <FontAwesomeIcon color={COLORS.darkBlue} icon={faSave} style={{ color: save1Color, fontSize: 14, marginRight: 12 }} />
                    }
                    <h4 style={{ display: "flex", alignItems: "center", color:save1Color, fontSize: 14, height:'100%', margin:0, fontFamily: 'OpenSans-Bold' }}>
                      Save
                    </h4>
                  </div>
                </Button> 
            </div>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 className='formName' style={{ textColor }}>Your Name</h3>
                </div>
                <Input disabled={true} placeholder="Your Full Name" value={this.state.name} className='bankInput' />
              </div>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 className='formName' style={{ color: textColor }}>Legal Entity Name</h3>
                </div>
                <Input disabled={true} value={this.state.entity} placeholder="Full legal name of production company" className='bankInput'  />
              </div>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 className='formName' style={{ color: textColor }}>Legal Entity Country</h3>
                </div>
                <Input disabled={true} placeholder="Your Full Name" value={this.state.country} className='bankInput' />
              </div>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 className='formName' style={{ color: textColor }}>Contact Mobile</h3>
                </div>
                <Input disabled={true} value={this.state.mobile} placeholder="Your Mobile Number" className='bankInput' />
              </div>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 className='formName' style={{ color: textColor }}>Contact Email</h3>
                </div>
                <Input disabled={true} type='email' value={this.state.email} placeholder="Your Primary Email Address" className='bankInput' />
              </div>
             <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Website</h3>
                </div>
                <Input value={this.state.website} onChange={(e) => { this.handleWebsite(e) }}
                  disabled={confirmed} placeholder="https://www.askdesis.com" className='bankInput' />
            </div>
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>PAN Number</h3>
                </div>
                <Input value={this.state.panNumber} onChange={(e) => { this.handlePanNumber(e) }} className='bankInput3'
                  disabled={confirmed} placeholder="Enter PAN Number and upload id" style={{ width: '75%' }} suffix={this.suffixDoc(1, confirmed)} />
            </div>
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>GST Number</h3>
                </div>
                <Input value={this.state.gstNumber} onChange={(e) => { this.handleGstNumber(e) }} className='bankInput3'
                  disabled={confirmed} placeholder="Enter GST Number" style={{ width: '75%' }} suffix={this.suffixDoc(2, confirmed)} />
            </div>
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Business Registration</h3>
                </div>
                <Input value={this.state.regDocName} onChange={(e) => { this.handleRegDocName(e) }} className='bankInput3'
                  disabled={confirmed} placeholder="Name of the Business Registration Document" style={{ width: '75%' }} suffix={this.suffixDoc(3, confirmed)} />
            </div>
            <div style={{ display: 'flex', flex:1, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
              <div style={{ display: "flex", alignSelf: "center", width: '25%', height:'100%' }}>
                <h3 style={textStyle}>Business Address</h3>
              </div>
              <div style={{ width: '75%' }}>
                <Input className='bankInput2' value={this.state.address1} onChange={(e) => { this.handleAddress1(e) }}
                  disabled={confirmed} placeholder="Address Line 1" />
                <Input className='bankInput2' value={this.state.address2} onChange={(e) => { this.handleAddress2(e) }}
                  disabled={confirmed} placeholder="Address Line 2" />
                <Input className='bankInput2' value={this.state.city} onChange={(e) => { this.handleCity(e) }}
                  disabled={confirmed} placeholder="City" />
                <Input className='bankInput2' value={this.state.postalCode} onChange={(e) => { this.handlePostalCode(e) }}
                  disabled={confirmed} placeholder="Postal Code" />
                <Input className='bankInput2' value={this.state.state} onChange={(e) => { this.handleState(e) }}
                  disabled={confirmed} placeholder="State" />
              </div>
            </div>
        </div>  
        <div style={{ display: 'flex', justifyContent:'center', marginTop: 24 }}>
          <h5 className="Agree" style={{ fontSize: 14, textAlign:'left', alignSelf:'center', margin: 0, color: COLORS.redClose, fontFamily:'OpenSans-Bold' }}>
          {disabled ? warningText : ''}
          </h5>
        </div>

        <div style={{ marginTop: 24, border: '2px solid #1a2a3a'  }}>
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.yellow, borderBottom: '2px solid #1a2a3a' }}>
                <div style={{ display: "flex", flex:1, justifyContent:'center', alignItems: "center", width: '100%', height:'100%' }}>
                    <FontAwesomeIcon color={COLORS.darkBlue} icon={faUserTie} style={{ fontSize: 24, margin: '12px' }} />
                    <h2 style={{ fontSize: 18, fontFamily: 'OpenSans-Bold', alignSelf:'center', textAlign:'center', color: COLORS.darkBlue, marginBottom: 0 }}>
                    Main Business Owner Details
                    </h2>
                    <FontAwesomeIcon color={COLORS.darkBlue} icon={faUserTie} style={{ fontSize: 24, margin: '12px' }} />                  
                </div>
                <Button onClick={() => { this.saveButton(this.state.save2, 2) }} className='caption' style={{ position:'absolute', display: confirmed ? 'none' : "flex", 
                alignItems: "center", justifyContent:'center', right: 0, width: 100, height: 32, background: save2BG, borderRadius: 3, 
                margin: 10, opacity: opacity2 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent:'center' }}>
                    { this.state.saving2
                    ?
                    <Spin size='small' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 12 }} />
                    :
                    <FontAwesomeIcon color={COLORS.darkBlue} icon={faSave} style={{ color: save1Color, fontSize: 14, marginRight: 12 }} />
                    }
                    <h4 style={{ display: "flex", alignItems: "center", color:save1Color, fontSize: 14, height:'100%', margin:0, fontFamily: 'OpenSans-Bold' }}>
                      Save
                    </h4>
                  </div>
                </Button>
            </div>             
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Owner Full Name</h3>
                </div>
                <Input value={this.state.ownerName} onChange={(e) => { this.handleOwnerName(e) }}
                  disabled={confirmed||disabled} placeholder="Owner Full Name" className='bankInput' />
            </div>
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Date of Birth</h3>
                </div>
                <Input value={this.state.ownerDob} onChange={(e) => { this.handleDob(e) }}
                  disabled={confirmed||disabled} placeholder="DD / MM / YYYY" className='bankInput' />
            </div>
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Designation</h3>
                </div>
                <Input value={this.state.designation} onChange={(e) => { this.handleDesignation(e) }}
                  disabled={confirmed||disabled} placeholder="CEO, MD, Partner, etc." className='bankInput' />
            </div>
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>PAN Number</h3>
                </div>
                <Input value={this.state.ownerPan} onChange={(e) => { this.handleOwnerPanNumber(e) }} className='bankInput3'
                  disabled={confirmed||disabled} placeholder="Enter PAN Number and upload id" style={{ width: '75%' }} suffix={this.suffixDoc(4, confirmed)} />
            </div>
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Aadhar Number</h3>
                </div>
                <Input value={this.state.ownerAadhar} onChange={(e) => { this.handleAadhar(e) }} className='bankInput3'
                  disabled={confirmed||disabled} placeholder="Aadhar Number" style={{ width: '75%' }} suffix={this.aadharDoc(confirmed)} />
            </div>
            <div style={{ display: 'flex', flex:1, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
              <div style={{ display: "flex", alignSelf: "center", width: '25%', height:'100%' }}>
                <h3 style={textStyle}>Owner Address</h3>
              </div>
              <div style={{ width: '75%' }}>
                <Input className='bankInput2' value={this.state.ownerAddress1} onChange={(e) => { this.handleOwnerAddress1(e) }}
                  disabled={confirmed||disabled} placeholder="Address Line 1" />
                <Input className='bankInput2' value={this.state.ownerAddress2} onChange={(e) => { this.handleOwnerAddress2(e) }}
                  disabled={confirmed||disabled} placeholder="Address Line 2" />
                <Input className='bankInput2' value={this.state.ownerCity} onChange={(e) => { this.handleOwnerCity(e) }}
                  disabled={confirmed||disabled} placeholder="City" />
                <Input className='bankInput2' value={this.state.ownerPostalCode} onChange={(e) => { this.handleOwnerPostal(e) }}
                  disabled={confirmed||disabled} placeholder="Postal Code" />
                <Input className='bankInput2' value={this.state.ownerState} onChange={(e) => { this.handleOwnerState(e) }}
                  disabled={confirmed||disabled} placeholder="State" />
              </div>
            </div>
        </div>  
        <div style={{ marginTop: 40, border: '2px solid #1a2a3a'  }}>
            <div style={{ display: 'flex', flex:1, height: 54, justifyContent:'center', backgroundColor: COLORS.yellow, borderBottom: '2px solid #1a2a3a' }}>
                    <div style={{ display: "flex", flex:1, justifyContent:'center', alignItems: "center", width: '100%', height:'100%' }}>
                        <FontAwesomeIcon color={COLORS.darkBlue} icon={faUniversity} style={{ fontSize: 24, margin: '12px' }} />
                        <h2 style={{ fontSize: 18, fontFamily: 'OpenSans-Bold', alignSelf:'center', textAlign:'center', color: COLORS.darkBlue, marginBottom: 0 }}>
                        Bank Details
                        </h2>
                        <FontAwesomeIcon color={COLORS.darkBlue} icon={faUniversity} style={{ fontSize: 24, margin: '12px' }} />                  
                    </div>                    
                    <Button onClick={() => { this.saveButton(this.state.save3, 3) }} className='caption' style={{ position:'absolute', 
                    display: confirmed ? 'none' : "flex", alignItems: "center", justifyContent:'center', right: 0, width: 100, height: 32, background: save3BG, 
                    borderRadius: 3, margin: 10, opacity: opacity3 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent:'center' }}>
                    { this.state.saving3
                    ?
                    <Spin size='small' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 12 }} />
                    :
                    <FontAwesomeIcon color={COLORS.darkBlue} icon={faSave} style={{ color: save1Color, fontSize: 14, marginRight: 12 }} />
                    }
                    <h4 style={{ display: "flex", alignItems: "center", color:save1Color, fontSize: 14, height:'100%', margin:0, fontFamily: 'OpenSans-Bold' }}>
                      Save
                    </h4>
                  </div>
                </Button>
            </div>             
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Bank Name</h3>
                </div>
                <Input value={this.state.bankName} onChange={(e) => { this.handleBankName(e) }}
                  disabled={confirmed||disabled} placeholder="Bank Name" className='bankInput' />
            </div>
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Bank Branch</h3>
                </div>
                <Input value={this.state.bankBranch} onChange={(e) => { this.handleBankBranch(e) }}
                  disabled={confirmed||disabled} placeholder="Bank Branch" className='bankInput' />
            </div>
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>IFSC Code</h3>
                </div>
                <Input value={this.state.ifscCode} onChange={(e) => { this.handleIfsc(e) }}
                  disabled={confirmed||disabled} placeholder="IFSC Code" className='bankInput' />
            </div>
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Account Number</h3>
                </div>
                <Input value={this.state.accountNumber} onChange={(e) => { this.handleAccountNumber(e) }}
                  disabled={confirmed||disabled} placeholder="Account Number" className='bankInput' />
            </div>
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Re-enter Account No.</h3>
                </div>
                <Input value={this.state.confirmAccount} onChange={(e) => { this.handleConfirmAccount(e) }}
                  disabled={confirmed||disabled} placeholder="Re-enter Account Number" className='bankInput' />
            </div>
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Upoad Cheque</h3>
                </div>
                <Input value={this.state.chequeNumber} onChange={(e) => { this.handleChequeNumber(e) }} className='bankInput3'
                  disabled={confirmed||disabled} placeholder="Upoad a blank and crossed out cheque" style={{ width: '75%' }} suffix={this.suffixDoc(5, confirmed)} />
            </div>
        </div>   
        <div style={{ display: confirmed ? 'none' : "flex", justifyContent:'center', marginTop: 12 }}>
          <h5 className="Agree" style={{ fontSize: 12, textAlign:'left', alignSelf:'center', margin: 0, color: COLORS.redClose, fontFamily:'OpenSans-Bold' }}>
          {this.state.errorMessage}
          </h5>
        </div> 
        <div style={{ display: "flex", justifyContent:'center', marginTop: 24 }}>
          <h5 className="Agree" style={{ whiteSpace: 'break-spaces', fontSize: 12, textAlign:'center', alignSelf:'center', margin: 0, color: COLORS.redClose, fontFamily:'OpenSans-Bold' }}>
          { confirmed ? ('You have confirmed all the above details on '+updatedTime+'. \nFor security reasons you can no longer edit these details.') : warningText2}
          </h5>
        </div> 
        <div style={{ display: "flex", justifyContent:'center', marginTop: 12 }}>
          <h5 className="Agree" style={{ fontSize: 12, textAlign:'left', alignSelf:'center', margin: 0, color: COLORS.redClose, fontFamily:'OpenSans-Bold' }}>
          {supportEmail}
          </h5>
        </div>        
        <div style={{ width: '100%', height: 60, marginTop: 24, display: confirmed ? 'none' : "flex", justifyContent:'center' }}>
          <div onClick={() => { this.confirmSubmitClicked(detailsEnabled) }} style={{ cursor: 'pointer', width: 244, height: 58, background: COLORS.eeeWhite, borderRadius: 5 }}>
            <Row style={{ width: 240, height: 54, background: detailsEnabled ? COLORS.lightgreen : COLORS.greya3, borderRadius: 3, margin: 2 }}>
              <div style={{ display: 'flex', alignItems:'center', width: '100%', height: 56, justifyContent:'center' }}>
                <FontAwesomeIcon color={detailsEnabled ? COLORS.white : COLORS.blue2a3a4a} icon={faCheckDouble} style={{ fontSize: 24, marginRight: 8 }} />
                <div className='col' style={{  }}>
                  <p style={{ color: detailsEnabled ? COLORS.white : COLORS.blue2a3a4a, fontSize: 18, marginBottom: 0, textAlign:'left', fontFamily: 'OpenSans-Bold' }}>
                    { this.state.confirmSubmit===0 ? 'Confirm & Submit' : 'Click Again To Submit' }
                  </p>
                </div>
              </div>
            </Row>
          </div>
        </div>            
        <div style={{ display: 'flex', width: '100%', justifyContent:'center' }}>
          <FontAwesomeIcon color={COLORS.blue3a4a5a} icon={faWater} style={{ fontSize: 36, margin: 48 }} />
        </div>
        </div>
        :
        <div style={{ height: 768 }}>
          <div style={{ marginTop: 40, border: '2px solid #1a2a3a'  }}>
            <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.yellow, borderBottom: '2px solid #1a2a3a' }}>
                <div style={{ display: "flex", flex:1, justifyContent:'center', alignItems: "center", width: '100%', height:'100%' }}>
                    <FontAwesomeIcon color={COLORS.darkBlue} icon={faBuilding} style={{ fontSize: 24, margin: '12px' }} />
                    <h2 style={{ fontSize: 18, fontFamily: 'OpenSans-Bold', alignSelf:'center', textAlign:'center', color: COLORS.darkBlue, marginBottom: 0 }}>
                      Business Details
                    </h2>
                    <FontAwesomeIcon color={COLORS.darkBlue} icon={faBuilding} style={{ fontSize: 24, margin: '12px' }} />                  
                </div>
            </div>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 className='formName' style={{ textColor }}>Your Name</h3>
                </div>
                <Input disabled={true} placeholder="Your Full Name" value={this.state.name} style={inputStyleDisabled} />
              </div>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 className='formName' style={{ color: textColor }}>Legal Entity Name</h3>
                </div>
                <Input disabled={true} value={this.state.entity} placeholder="Full legal name of production company" style={inputStyleDisabled} />
              </div>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 className='formName' style={{ color: textColor }}>Legal Entity Country</h3>
                </div>
                <Input disabled={true} placeholder="Your Full Name" value={this.state.country} style={inputStyleDisabled} />
              </div>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 className='formName' style={{ color: textColor }}>Contact Mobile</h3>
                </div>
                <Input disabled={true} value={this.state.mobile} placeholder="Your Mobile Number" style={inputStyleDisabled} />
              </div>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 className='formName' style={{ color: textColor }}>Contact Email</h3>
                </div>
                <Input disabled={true} type='email' value={this.state.email} placeholder="Your Primary Email Address" style={inputStyleDisabled} />
              </div>
        </div>  
          <div style={{ width: '100%', height: 60, marginTop: 40, display: 'flex', justifyContent:'center' }}>
            <div onClick={() => { this.props.openAccountLink() }} style={{ cursor: 'pointer', width: 244, height: 58, background: COLORS.eeeWhite, borderRadius: 5 }}>
              <Row style={{ width: 240, height: 54, background: COLORS.lightgreen, borderRadius: 3, margin: 2 }}>
                <div style={{ display: 'flex', alignItems:'center', width: '100%', height: 56, justifyContent:'center' }}>
                  <FontAwesomeIcon color={COLORS.white} icon={faUniversity} style={{ fontSize: 24, marginRight: 8 }} />
                  <div className='col' style={{  }}>
                    <p style={{ color: COLORS.white, fontSize: 18, marginBottom: 0, textAlign:'left', fontFamily: 'OpenSans-Bold' }}>{accountButton}</p>
                  </div>
                </div>
              </Row>
            </div>
          </div>
          <div style={{ width: '80%', marginLeft: '10%' }}>
            <p className="Agree" style={{ marginTop: 40, fontSize: 13, fontFamily: 'OpenSans-SemiBold', color: COLORS.yellow, lineHeight: 1.2 }}>
              {this.props.isVerified ? checkAccountText : bankText}
            </p>
            { this.props.isVerified
            ?
            <div/>            
            :
            <p className="Agree" style={{ whiteSpace: 'break-spaces', fontSize: 13, fontFamily: 'OpenSans-Bold', color: COLORS.redClose, lineHeight: 1.2 }}>
              {bankText2}<p className="Agree" style={{ fontSize: 13, fontFamily: 'OpenSans-SemiBold', color: COLORS.yellow, lineHeight: 1.2 }}>{bankText3}</p>
            </p>
            }
            <p className="Agree" style={{ marginTop: 40, fontSize: 13, fontFamily: 'OpenSans-Bold', color: COLORS.redClose, lineHeight: 1.2 }}>
              {supportEmail}
            </p>
          </div>
          <div style={{ display: 'flex', width: '100%', justifyContent:'center' }}>
            <FontAwesomeIcon color={COLORS.blue3a4a5a} icon={faWater} style={{ fontSize: 36, margin: 48 }} />
          </div>
        </div>
        }
        
    </div>
  );
  }
}